<template>
  <div id="app">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <div v-if="!isLogin" class="ba">
      <h6>&copy;2019-2022 All Right Reserved.阳光体育</h6>
    </div>
    <main-tab-bar v-if="isLogin" v-show="isShow"></main-tab-bar>
    <!--    <tab-bar-two></tab-bar-two>-->
  </div>
</template>
<script>

import MainTabBar from "components/content/mainTabBar/MainTabBar";
import TabBarTwo from "@/components/content/TabBarTwo/TabBarTwo";
import {CheckLogin} from "@/network/check";
import {AdmLogin, TeaLogin, StuLogin} from "@/network/login";
import Vue from 'vue';
import {
  Dialog,
} from 'vant';

Vue.use(Dialog)
export default {
  name: 'App',
  data() {
    return {}
  },
  computed: {
    isLogin() {
      return this.$store.state.islogin;
    },
    isShow() {
      return this.$route.path.indexOf('home') != -1 || this.$route.path.indexOf('profile') != -1 || this.$route.path.indexOf('DataCenter') != -1;
    }
  },
  methods: {
    checks() {

    }
  },
  created() {
    console.log("%c HHSTU", "color:#2980b9;font-size:5em")
    // console.log("         ******     ******      \n" +
    //   "      **********   **********         \n" +
    //   "    ************* *************    \n" +
    //   "   *****************************     \n" +
    //   "   *****************************     \n" +
    //   "   *****************************\t   \n" +
    //   "    ***************************        \n" +
    //   "      ***********************          \n" +
    //   "        *******************           \n" +
    //   "          ***************              \n" +
    //   "            ***********                \n" +
    //   "              *******                 \n" +
    //   "                ***                  \n"+
    //   "                 *                   \n")
    // console.log(
    //   "%c      感受世界的温度，\n" +
    //   "      黄科大信息技术协会，发挥你所有的潜力。\n" +
    //   "      加入我们，邮箱：joarn.word@gmail.com", "color:#2c3e50;font-size:5px");

    if (this.$route.path.indexOf('login') != -1)
      return;

    if (this.$cookies.get("user") === "admin") {
      let info = this.$cookies.get("info");
      AdmLogin(info.username, info.pwd)
    } else if (this.$cookies.get("user") === "teacher") {
      let info = this.$cookies.get("info");
      TeaLogin(info.tNum, info.pwd);
    } else if (this.$cookies.get("user") === "student") {
      let info = this.$cookies.get("info");
      StuLogin(info.sName, info.sNum);
    }

    window.setInterval(() => {
      return;
      ;
      if (this.$route.path.indexOf('login') != -1)
        return;
      CheckLogin().then(res => {
        if (!res) {
          this.$cookies.remove("islogin");
          this.$cookies.remove("user");
          this.$cookies.remove("info");
          this.$router.replace("/login")
          // location.reload();
          Dialog.alert({
            title: "错误",
            message: "登录失效，请重新登录"
          }).then(() => {
            // on close
          });
        }
      })
    }, 1000 * 60);
  },
  mounted() {
    if (this.$cookies.get("islogin")) {
      this.$store.commit('logined');
    } else ;
    //console.log("testttt");
  },
  components: {TabBarTwo, MainTabBar}
}
</script>
<style>
@import "./assets/css/base.css";

.ba {
  height: 30px;
  line-height: 35px;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  background-color: #a8d8ea;
  color: #fff;
  font-family: Arial;
  font-size: 14px;
  letter-spacing: 1px;

}
</style>
